import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import { mb, mt } from "styled-components-spacing"

export const headingBase = css`
  font-family: ${props => props.theme.fontStacks.sans};
  font-weight: bold;
  line-height: 1;
  margin: 1em 0;

  ${props =>
    props.centered &&
    css`
      text-align: center;
    `}
`

const marginProps = css`
  ${props => props.noMt && `margin-top: 0;`}
  ${props => props.noMb && `margin-bottom: 0;`}

  ${props => props.mt !== undefined && mt(props.mt)}
  ${props => props.mb !== undefined && mb(props.mb)}
`

const HeadingPropTypes = {
  centered: PropTypes.bool,
  noMt: PropTypes.bool, // legacy
  noMb: PropTypes.bool, // legacy
  mb: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  mt: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
}

export const H1 = styled.h1`
  ${headingBase};
  margin: 0 0 24px;
  font-size: 24px;
  ${marginProps};
  ${props =>
    props.big
      ? breakpoint("md")(css`
          font-size: 64px;
        `)
      : breakpoint("md")(css`
          font-size: 32px;
        `)}
`

H1.propTypes = { big: PropTypes.bool, ...HeadingPropTypes }

export const H2 = styled.h2`
  ${headingBase};
  margin: 16px 0;
  font-size: 24px;
  ${marginProps};
  ${props =>
    props.big
      ? breakpoint("md")(css`
          font-size: 50px;
        `)
      : breakpoint("md")(css`
          font-size: 24px;
        `)}
`
H2.propTypes = { big: PropTypes.bool, ...HeadingPropTypes }

export const H3 = styled.h3`
  ${headingBase};
  font-size: 20px;
  margin: 16px 0;
  ${marginProps}
`
H3.propTypes = HeadingPropTypes

export const H4 = styled.h4`
  ${headingBase};
  margin: 0;
  ${marginProps};
  font-size: 16px;
`
H4.propTypes = HeadingPropTypes

export const H5 = styled.h5`
  ${headingBase};
  margin-bottom: 10px;
  font-family: ${props => props.theme.fontStacks.sans};
  color: ${props => props.theme.colors.darkGrey};
  font-size: 14px;
  line-height: 1.25;
  text-transform: uppercase;
  font-weight: normal;
  text-align: left;
  letter-spacing: 1.2px;

  ${props =>
    props.quiet &&
    css`
      color: ${props => props.theme.colors.baseGrey};
    `}
`
H5.propTypes = { quiet: PropTypes.bool, ...HeadingPropTypes }
